const formatDateTime = (dateTimeString) => {
  const date = new Date(dateTimeString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;
  const formattedTime = `${hours}:${minutes}`;

  return `${formattedDate} ${formattedTime}`;
};
const formatDateNaissance = (dateTimeString) => {
  // Crée un objet Date à partir de la chaîne de caractères
  const date = new Date(dateTimeString);

  // Extrait l'année, le mois et le jour
  const year = String(date.getUTCFullYear()).slice(-2); // Utilise getUTCFullYear() pour les dates UTC
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Les mois sont indexés à partir de 0
  const day = String(date.getUTCDate()).padStart(2, "0");

  // Formate la date en "yy/mm/dd"
  const formattedDate = `${year}/${month}/${day}`;

  return formattedDate;
};
const formatDate = (dateTimeString) => {
  const date = new Date(dateTimeString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;
  const formattedTime = `${hours}:${minutes}`;

  return `${formattedDate} ${formattedTime}`;
};
export { formatDateNaissance, formatDate };

export default formatDateTime;
